import { render, staticRenderFns } from "./WoundMappingCard.vue?vue&type=template&id=6c662655&"
import script from "./WoundMappingCard.vue?vue&type=script&lang=js&"
export * from "./WoundMappingCard.vue?vue&type=script&lang=js&"
import style0 from "./WoundMappingCard.vue?vue&type=style&index=0&id=6c662655&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports